import * as React from 'react';
function IconPremium(props) {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props },
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { d: "M0 0h24v24H0z" }),
            React.createElement("path", { stroke: "currentColor", strokeWidth: 2, d: "M2.5 9l4.497-5H17l4.5 5L12 20z" }),
            React.createElement("path", { stroke: "currentColor", strokeWidth: 2, strokeLinecap: "square", d: "M4 9h16" }),
            React.createElement("path", { d: "M16.707 8l-4.71 13.528-1.504-1.742L14.596 8h2.11zM11.836 3L9.4 10H7.29l2.436-7h2.11z", fill: "currentColor", fillRule: "nonzero" }))));
}
export default IconPremium;
//# sourceMappingURL=IconPremium.js.map